export default {
    state: {
        initData: {}
    },
    mutations: {
        setInitData(state: any, value: any) {
            state.initData = value;
        },
    },
    actions: {},
}
